import Config from 'react-native-config'
import { LinkingOptions } from '@react-navigation/native'
import { RootStackParamList } from './types'

const parseUpsellOffer = (value: string) => {
  try {
    return JSON.parse(value)
  } catch {
    return value
  }
}

const commonDeepLinks = {
  AddMeal: {
    path: 'app/modals/newMeal',
  },
  AddActivity: {
    path: 'app/modals/newActivity',
  },
  AddMeasurement: {
    path: 'app/modals/newMeasurement',
  },
  AddJournalEntry: {
    path: 'app/modals/newJournalEntry',
  },
  AddonCheckout: {
    path: 'app/addonCheckout',
  },
  Chat: {
    path: 'app/chat',
  },
  NoraConversationScreen: {
    path: 'app/chat/:conversationProviderId',
  },
  NoraReportScreen: {
    path: 'app/healthDataReport/:reportId',
  },
  CoursesModule: {
    path: 'app/learn/module',
  },
  OnboardingChecklist: {
    path: 'app/onboardingChecklist',
  },
  Integrations: {
    path: 'app/settings/integrations',
  },
  TerraFitbitGoogleHealthAnnouncement: {
    path: 'app/terraFitbitGoogleHealthAnnouncement',
  },
  InsightsDetailedPage: {
    path: 'app/insights/:statSection',
  },
  CompareMealsDetails: {
    path: 'app/compareMeals/:mealIds',
  },
  TerraProvider: {
    path: 'app/settings/terra/:provider',
  },
  SensorSettings: {
    path: 'app/settings/sensor',
  },
  DexcomSensorSettings: {
    path: 'app/settings/dexcomSensor',
  },
  ProgramDetails: {
    path: 'app/programs/:subscriptionId?',
  },
  ManageSubscriptions: {
    path: 'app/programs/manage',
  },
  ChurnRecoveryOptions: {
    path: 'app/churnRecoveryOptions',
  },
  ChurnRecoveryUpsellOffer: {
    path: 'app/churnRecoveryUpsellOffer',
  },
  ChurnRecoveryProactiveUpsellOffer: {
    path: 'app/churnRecoveryProactiveUpsellOffer',
  },
  ChurnRecoveryMembershipOffer: {
    path: 'app/churnRecoveryMembershipOffer',
  },
  CancelSubscriptionConfirmation: {
    path: 'app/cancelSubscriptionConfirmation',
  },
  ChurnMonthlyCGMOffer: {
    path: 'app/churnMonthlyCGMOffer',
  },
  Questionnaire: {
    path: 'app/questionnaire/:questionnaire',
  },
  InsuranceQuestionnaire: {
    path: 'app/insuranceQuestionnaire',
  },
  CheckConnection: {
    path: 'app/checkConnection',
  },
  TutorialsGroup: {
    path: 'app/tutorialGroup/:group',
  },
  VideoCallsStartModal: {
    path: 'app/videoCalls/start',
  },
  VideoCallsGettingStartedScreen: {
    path: 'app/videoCalls/gettingStarted',
  },
  VideoCallsUpsellDetailsModal: {
    path: 'app/videoCalls/upsellDetails',
  },
  VideoCallModal: {
    path: 'app/videoCalls/confirmed',
  },
  VideoCallCheckIn: {
    path: 'app/videoCalls/checkIn',
  },
  AllVideoCalls: {
    path: 'app/videoCalls/all',
  },
  PaidCallsIntroScreen: {
    path: 'app/videoCalls/paidCallsIntro',
  },
  ClaimFreeVideoCallModal: {
    path: 'app/videoCalls/claimFreeVideoCall',
  },
  FreeVideoCall: {
    path: 'app/videoCalls/freeVideoCall',
  },
  ReferralVideoCall: {
    path: 'app/videoCalls/referral',
  },
  NutritionistSwitchModal: {
    path: 'app/nutritionistSwitch',
  },
  NutritionistSwitchScreen: {
    path: 'app/nutritionistSwitchScreen',
  },
  CoachInfoModal: {
    path: 'app/nutritionistInfo',
  },
  CoachSwitchSummaryScreen: {
    path: 'app/coachSwitchSummaryScreen',
  },
  CMSTutorial: {
    path: 'app/tutorials/:tutorialId',
  },
  NotificationsSettings: {
    path: 'app/settings/notifications',
  },
  NotificationInbox: {
    path: 'app/notifications',
  },
  UserSettings: {
    path: 'app/settings/system',
  },
  CallScheduling: {
    path: 'app/callScheduling',
  },
  RescheduleVideoCallToEarlierSlot: {
    path: 'app/videoCalls/rescheduleToEarlierSlot',
  },
  SetWeightLossGoal: {
    path: 'app/videoCalls/setWeightLossGoal',
  },
  ConfirmWeightLossRecurrence: {
    path: 'app/videoCalls/confirmWeightLossRecurrence',
    parse: {
      weightLossRate: (value: string) => Number(value),
      currentWeight: (value: string) => Number(value),
    },
  },
  LabResultsScreen: {
    path: 'app/labResults',
  },
  AddLabResults: {
    path: 'app/labResults/new',
  },
  LabPanelsScreen: {
    path: 'app/labPanels',
  },
  CreatePaymentMethod: {
    path: 'app/marketplace/createPaymentMethod',
  },
  SubmitInsuranceCardScreen: {
    path: 'app/submitInsuranceCard',
  },
  InsuranceStatus: {
    path: 'app/insuranceStatus',
  },
  InsurancePolicyForm: {
    path: 'app/insurancePolicyForm',
  },
  WeightLossExperienceDesiredWeightCompleted: {
    path: 'app/weightLossExperience/completed',
  },
  WeightLossExperiencePersonalPlan: {
    path: 'app/weightLossExperience/personalPlan',
  },
  VideoCallsSteloUpsell: {
    path: 'app/videoCalls/steloUpsell',
  },
  MfpInstructions: {
    path: 'app/integrationInstructions/my_fitness_pal',
  },
  SendMessageToCoach: {
    path: 'app/sendMessageToCoach',
  },
  SupportHub: {
    path: 'app/supportHub',
  },
  ProductExplanation: {
    path: 'app/productExplanation',
    parse: {
      upsellOffer: parseUpsellOffer,
    },
  },
  StressManagementIntroScreen: {
    path: 'app/videoCalls/stressManagement',
  },
  PositiveRatingModal: {
    path: 'app/modals/positiveRating',
  },
  TrustpilotReview: {
    path: 'app/trustpilotReview',
  },
}

const largeScreenNavigatorDeepLinks = {
  Drawer: {
    path: 'app',
    screens: {
      Dashboard: {
        path: '',
        screens: {
          Home: {
            path: 'home',
          },
        },
      },
      Account: {
        path: 'account',
      },
      Events: {
        path: 'events',
      },
      Learn: {
        path: 'learn',
      },
      Insights: {
        path: 'insights',
      },
      NutritionistHub: {
        path: 'nutritionistHub',
      },
    },
  },
}

const smallScreenNavigatorDeepLinks = {
  Drawer: {
    path: 'app',
    screens: {
      Dashboard: {
        path: '',
        screens: {
          Home: {
            path: 'home',
          },
          Events: {
            path: 'events',
          },
          Learn: {
            path: 'learn',
          },
          Insights: {
            path: 'insights',
          },
          NutritionistHub: {
            path: 'nutritionistHub',
          },
        },
      },
    },
  },
  Account: {
    path: 'app/account',
  },
}

const onboardingDeepLinks = {
  Onboarding: {
    path: 'onboarding',
    screens: {
      TerraProvider: {
        path: 'terraProvider/:provider',
      },
    },
  },
}

const coreNavigatorDeepLinks = {
  ...commonDeepLinks,
  ...onboardingDeepLinks,
  FriendReferral: {
    path: 'refer-a-friend',
  },
  AppSettings: {
    path: 'app/settings',
  },
}

export const linking = ({
  initialRouteName,
  hasLargeScreen,
  isAuth,
}: {
  initialRouteName: keyof RootStackParamList
  hasLargeScreen: boolean
  isAuth?: boolean
}): LinkingOptions<RootStackParamList> => {
  const authenticatedDeepLinks = {
    ...coreNavigatorDeepLinks,
    ...(hasLargeScreen ? largeScreenNavigatorDeepLinks : smallScreenNavigatorDeepLinks),
  }

  const unauthenticatedDeepLinks = {
    Auth: {
      screens: {
        PasswordReset: {
          path: 'auth/reset/:passwordToken',
        },
        ReferralVideoCall: {
          path: 'app/videoCalls/referral',
        },
      },
    },
  }

  const deepLinks = isAuth ? authenticatedDeepLinks : unauthenticatedDeepLinks

  return {
    prefixes: [Config.LINK_PREFIX, `${Config.APP_SCHEME}://`],
    config: {
      initialRouteName,
      screens: deepLinks,
    },
  }
}
